import instance from "./api";

export default {
  getCountries: async () => {
    return instance.get("/countries");
  },
};
